import i18n from "i18next";
import { z } from "zod";
import { notificationSchema } from "../utils";

const LANG_BASE = "vessel-call.port-services.fields";

export const specialInstructionsOnlySchema = () =>
  z.object({
    attachment: z.any().optional(),
    notes: z
      .string()
      .max(
        1000,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.notes`),
          max: 1000,
        }),
      )
      .optional(),
  });
export const approveByOperationsLoadingAndOffloadingSchema = () =>
  specialInstructionsOnlySchema().merge(notificationSchema);

export type ApproveBySchema = z.infer<
  ReturnType<typeof approveByOperationsLoadingAndOffloadingSchema>
>;
